/** Search param that puts the content view in the view of imported pages, so it can open in its own window. */
export const IMPORTED_VIEW_PARAM = 'imported';

/** Whether the URL asks for the view of imported pages. */
export const isImportedView = (searchParams: URLSearchParams): boolean => searchParams.get(IMPORTED_VIEW_PARAM) === '1';
